<div style="height:100%">
    <div class="outer-div">
        <!-- -------- section :1------------ -->
        <div class="first-div">
            <div class="dropdown-divs">
                <!-- src/app/dropdown/dropdown.component.html -->
                <div class="display-div">
                    <!-- <div>Snapshot Types: </div> -->
                    <div (click)="openTypeDropdown($event)" class="dd">
                        <p style="padding-top: 2.5%;padding-left: 7%;">{{typeHeader}}</p>
                        <!-- <div class="downarrow" style="font-weight: bold;"></div> -->
                        <img src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg" alt="" class="icon">

                    </div>
                    <div *ngIf="typeDropdownPopup" class="a" DocumentClick (DocumentClicked)="closeTypeDropdown()">
                        <div *ngFor="let item of snapshotTypes" class="dropdown-values"
                            [ngClass]="{'selectedDropdownItem': item.selected}" (click)="onTypeClick(item)">
                            <div style="padding-top:3%"><input type="radio" name="type" [value]="item.value"
                                    [checked]="item.selected" class="inputValues">
                            </div>
                            <div class="itemData" title="{{item.name}}">{{item.name}}</div>
                        </div>
                    </div>

                </div>

                <div class="display-div">
                    <!-- <div>Sections: </div> -->
                    <div (click)="openSectionDropdown($event)" class="dd" [ngClass]="{'disabled': sectionDisable}">
                        <p style="padding-top: 2.5%;padding-left: 7%;">{{sectionHeader}}</p>
                        <img src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg" alt="" class="icon">
                    </div>
                    <div *ngIf="sectionDropdownPopup" class="b" DocumentClick
                        (DocumentClicked)="closeSectionDropdown()">
                        <div *ngFor="let item of sections" class="dropdown-values"
                            [ngClass]="{'selectedDropdownItem': item.selected}" (click)="onSectionClick(item)">
                            <div style="padding-top:3%"><input type="radio" name="section" [value]="item.value"
                                    [checked]="item.selected" class="inputValues">
                            </div>
                            <div class="itemData" title="{{item.name}}">{{item.name}}</div>
                        </div>
                    </div>

                </div>

                <div class="display-div">
                    <!-- <div>Sub sections: </div> -->
                    <div (click)="openSubsectionDropdown($event)" class="dd"
                        [ngClass]="{'disabled': subSectionDisable}">
                        <p style="padding-top: 2.5%;padding-left: 7%;">{{subSectionHeader}}</p>
                        <img src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg" alt="" class="icon">
                    </div>
                    <div *ngIf="subSectionDropdownPopup" class="c" DocumentClick
                        (DocumentClicked)="closeSubsectionDropdown()">
                        <div *ngFor="let item of subSections" class="dropdown-values"
                            [ngClass]="{'selectedDropdownItem': item.selected}" (click)="onSubsectionClick(item)">
                            <div style="padding-top:3%"><input type="radio" name="subSection" [value]="item.value"
                                    [checked]="item.selected" class="inputValues">
                            </div>
                            <div class="itemData" title="{{item.name}}">{{item.name}}</div>
                        </div>
                    </div>

                </div>

                <div class="display-div">
                    <div class="widgetInfoIcon" (click)="openPdfInNewTab()">
                        <img class="widgetInfoIconImage"
                            src="../../../../assets/ImagesSnapshot/Public/Widget_Library_Info_Icon.svg" width="20px"
                            height="20px">
                    </div>
                </div>

            </div>

            <div>
                <h5 class="page-no">PAGE:{{pageCounter}}</h5>
                <hr>
            </div>
        </div>

        <!-- ------------- section:2 ----------- -->
        <div class="data-div">
            <div class="table-button-block" *ngIf="!tableClicked">

                <!-- -----Table Content---- -->
                <div class="table-container">
                    <div class="table-row header">
                        <div class="table-cell col1 col">Widget No.</div>
                        <div class="table-cell col2 col">Widget Name</div>
                        <div class="table-cell col3 col col3-header">Visualization</div>
                        <div class="table-cell col4 col">Metric</div>
                        <div class="table-cell col5 col">Trend</div>
                        <div class="table-cell col6 col">Info Icon</div>
                    </div>
                    <div class="row-body" (click)="onPageClicked()" style="overflow:auto">
                        <div *ngFor="let row of tableData; let i = index" [ngClass]="'row' + i" class="table-row">
                            <div class="table-cell col1 row">
                                <div>{{ row.widgetNumber }}</div>
                            </div>
                            <div class="table-cell col2 row">
                                <input type="text" style="width:100%;height:1.7rem" [(ngModel)]="row.widgetName">
                            </div>
                            <div class="table-cell col3 row">
                                <div>{{ row.visualization }}</div>
                            </div>
                            <div class="table-cell col4 row">
                                <!-- <div>{{ row.metric }}</div> -->
                                <div class="mainmetriccolumn" *ngFor="let i of row.metric.sublist">
                                    <div class="submetricname" *ngIf="row.metric.sublist.length>1">{{i.subWidgetName}}:
                                    </div>
                                    <div class="custom-dropdown"
                                        [style]="{'width': row.metric.sublist.length > 1 ? '75%' : '100%'}">
                                        <div class="custom-select" #select
                                            [style]="(row.metric.isDropdownOpen && i.isDropdown)?'border: 1.4px solid var(--BHP-Primary-DarkGreen3, rgba(128, 42, 183, 1));box-shadow: 0px 0px 12px 0px rgba(191, 191, 191, 0.15);':'border: 1px solid var(--BHP-Primary-Grey1, rgba(201, 201, 201, 1));box-shadow:0px'"
                                            (click)="togglemetricDropdown(row,i,row.metric.sublist,select)">
                                            <div class="selected-option">{{i.option}}</div>
                                            <div class=" arrow1">
                                                <div class="arrowToggle arrowCollapsedIcon"></div>
                                            </div>
                                        </div>
                                        <div class="custom-options" #options
                                            [ngClass]="{'dropdown-above': i.isDropdownAbove, 'dropdown-below': !i.isDropdownAbove}"
                                            *ngIf="row.metric.isDropdownOpen && i.isDropdown"
                                            (mousescroll)="row.metric.isDropdownOpen = false"
                                            (mouseleave)="row.metric.isDropdownOpen = false">
                                            <div class="dropdown-container">
                                                <div class="search-reset">
                                                    <div class="sub-items-search">
                                                        <input class="searchinput" type="text" placeholder="Search"
                                                            [(ngModel)]="searchmetric" autocomplete="off"
                                                            name="searchmetric"
                                                            (ngModelChange)="filterOptions(i,row.metric.metric_select!=3 || metricGroupLength == 0 ?row.metric.metricselect1and2:row.metric.metricselect3,row.metric.metric_select)" />
                                                        <div class="search-icon">
                                                            <div class="search-icon-image"></div>
                                                        </div>
                                                    </div>
                                                    <div class="reset-button"
                                                        (click)="resetmetricselections(row.widgetNumber,i.subWidgetName,row.metric,row.metric.metric_select!=3 || metricGroupLength == 0 ?row.metric.metricselect1and2:row.metric.metricselect3,pageCounter,i,'')">
                                                        <div class="resetbtn"></div>
                                                    </div>
                                                </div>
                                                <div class="custom-option">
                                                    <div *ngIf="row.metric.metric_select!=3 || metricGroupLength == 0 ">
                                                        <div class="metricLev1" *ngFor="let lev1 of i.filteredoptions">
                                                            <div class="custom-select-lev1"
                                                                [style]="lev1.isSelected?'background-color:#efeeee;font-weight: bold;':'background-color:transparent;font-weight: normal;'"
                                                                *ngIf="row.metric.metric_select!=3 || metricGroupLength == 0  && lev1.option!=''">
                                                                <div class="select_number"
                                                                    [style]="row.metric.metric_select==1?'display:none':'display:block'">
                                                                    {{lev1.selectorder>0?lev1.selectorder:" "}}</div>
                                                                <div class="checkbox-container">
                                                                    <input [id]="lev1.option"
                                                                        [checked]="lev1.isSelected"
                                                                        (click)="metriccheckboxchecked($event,row,lev1,i,row.metric.filteredoptions,pageCounter)"
                                                                        [type]="row.metric.metric_select==1?'radio':'checkbox'"
                                                                        [class.disabled]="i.maxlimitreached && !lev1.isSelected &&  i.maxselect!=0"
                                                                        class="checkbox" />
                                                                </div>
                                                                <label class="level1-name"
                                                                    [class.disabled]="i.maxselect!=0 && i.maxlimitreached && !lev1.isSelected"
                                                                    [title]="lev1.option"
                                                                    [for]="lev1.option">{{lev1.option}}</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div *ngIf="row.metric.metric_select==3 && metricGroupLength != 0">
                                                        <div class="metricLev1"
                                                            [ngClass]="lev1.isDropdownOpen?'border':''"
                                                            *ngFor="let lev1 of i.filteredoptions">
                                                            <div class="custom-select-lev1"
                                                                *ngIf="row.metric.metric_select==3 && metricGroupLength != 0 && lev1.option!=''">
                                                                <!-- <div class="checkbox-container">
                                                        <input type="radio" class="checkbox" />
                                                    </div> -->
                                                                <div class="level1-name" [title]="lev1.option"
                                                                    (click)="togglemetriclev1Dropdown(row,lev1,i.subWidgetName)">
                                                                    {{lev1.option}}
                                                                </div>
                                                                <div class=" arrow1"
                                                                    (click)="togglemetriclev1Dropdown(row,lev1,i.subWidgetName)">
                                                                    <div class="arrowToggle arrowCollapsedIcon"></div>
                                                                </div>
                                                            </div>
                                                            <div class="custom-options-lev2"
                                                                *ngIf="lev1.isDropdownOpen">
                                                                <div class="metricLev2"
                                                                    *ngFor="let lev2 of lev1.Level2">
                                                                    <div class="level2-container"
                                                                        [ngClass]="lev2.isSelected?'selectedDropdownItem':''">
                                                                        <div class="select_number"
                                                                            [style]="lev1.type=='radio'?'display:none':'display:block'"
                                                                            *ngIf="lev2.option!='' && lev1.option!=='METRIC GROUP'">
                                                                            {{lev2.selectorder>0?lev2.selectorder:" "}}
                                                                        </div>
                                                                        <div class="checkbox-container"
                                                                            *ngIf="lev2.option!=''">
                                                                            <input [id]="lev2.option" [type]="lev1.type"
                                                                                class="checkbox"
                                                                                [checked]="lev2.isSelected"
                                                                                [class.disabled]="i.maxselect!=0 && i.maxselect!=0 && (i.maxlimitreached && !lev2.isSelected)"
                                                                                (click)="metriccheckboxchecked($event,row,lev2,i,lev1,pageCounter)" />
                                                                        </div>
                                                                        <label class="level2-name" [for]="lev2.option"
                                                                            [class.disabled]="i.maxselect!=0 && i.maxlimitreached && !lev2.isSelected"
                                                                            [title]="lev2.option">{{lev2.option}}</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
							<div class="table-cell col5 row" [ngClass]="{ 'enableDisableTrend': !row.trendDiv }">
                                <input type="checkbox" [(ngModel)]="row.trend">
                            </div>
                            <div class="table-cell col6 row">
                                <textarea style="width:100%; height:100%;resize: none;" class="staticText"
                                    placeholder="Info Text" [(ngModel)]="row.infoIcon"></textarea>
                            </div>
                        </div>
                    </div>

                </div>

                <!-- OR -->
                <!-- <div class="table-container" *ngIf="subSectionDisable">
                    <div><h1>No Data Available</h1></div>
                 </div> -->


                <!-- ----Button content----- -->
                <div class="button-block">
                    <div class="SnapshotButtonFields" (click)="onResetClick()"
                        [class.disabled]="!isWidgetTypeSectionsConfigured">
                        <div class="button-img clearAll"></div>
                        <div class="SnapshotButton">Reset</div>
                    </div>
                    <div class="SnapshotButtonFields" style="display: none;">
                        <div class="button-img save"></div>
                        <div class="SnapshotButton">Save</div>
                    </div>
                    <div class="SnapshotButtonFields" (click)="submit()" [class.disabled]="true">
                        <div class="button-img submit"></div>
                        <div class="SnapshotButton">Submit</div>
                    </div>
                </div>
            </div>
            <div class="pagination-block">
                <!-- ----- Pagination div---- -->
                <div style="position:relative;top:33.5%;left:34%;">
                    <div class="leftPageDiv" (click)="onPageClick('left',pageCounter)"
                        [ngClass]="{'disabled':disableLeftClick}">
                        <span class="material-symbols-outlined leftPageClick">arrow_circle_left</span>
                    </div>
                    <div class="rightPageDiv" (click)="onPageClick('right',pageCounter)"
                        [ngClass]="{'disabled':disableRightClick}">
                        <span class="material-symbols-outlined rightPageClick">arrow_circle_right</span>
                    </div>
                </div>
            </div>
        </div>


    </div>
    <app-shared-popup-snapshot *ngIf="showErrorPopUp" [showErrorPopUp]="showErrorPopUp" [showInputPopUp]="false" [popUpParameter]="errorheaderTitle"
        [errorheaderTitle]="popUpTitle" [popUpMessage]="popUpMessage"
        (closeErrorPopUp)="onCloseIconClick($event)"></app-shared-popup-snapshot>

    <app-shared-popup-snapshot *ngIf="showConfirmationPopUp" [popUpParameter]="'Confirmation'"
        [errorheaderTitle]="popUpTitle" [popUpMessage]="popUpMessage" [showInputPopUp]="false"
        (closeConfirmationPopUp)="onCloseIconConfirmationPopupClicked($event)"></app-shared-popup-snapshot>

    <div class="overlay" *ngIf="tableClicked">
        <div class="close-btn" (click)="onCloseOverlay()">
            <div class="btn-text">
                <div class="button-img-close close"></div>
                <div class="SnapshotButton">Close</div>
            </div>
        </div>
        <div class="data-div overlay-content">
            <div class="table-button-block-overlay">
                <div>
                    <h5 class="page-no-overlay">PAGE:{{pageCounter}}</h5>
                    <hr>
                </div>
                <!-- -----Table Content---- -->
                <div class="table-container">
                    <div class="table-row header">
                        <div class="table-cell col1 col">Widget No.</div>
                        <div class="table-cell col2 col">Widget Name</div>
                        <div class="table-cell col3 col col3-header">Visualization</div>
                        <div class="table-cell col4 col">Metric</div>
                        <div class="table-cell col5 col">Trend</div>
                        <div class="table-cell col6 col">Info Icon</div>
                    </div>
                    <div class="row-body-overlay" style="overflow:auto;height: 52vh !important;">
                        <div *ngFor="let row of tableData; let i = index" [ngClass]="'row' + i" class="table-row">
                            <div class="table-cell col1 row">
                                <div>{{ row.widgetNumber }}</div>
                            </div>
                            <div class="table-cell col2 row">
                                <input type="text" style="width:100%;height:1.7rem" [(ngModel)]="row.widgetName">
                            </div>
                            <div class="table-cell col3 row">
                                <div>{{ row.visualization }}</div>
                            </div>
                            <div class="table-cell col4 row">
                                <!-- <div>{{ row.metric }}</div> -->
                                <div class="mainmetriccolumn" *ngFor="let i of row.metric.sublist">
                                    <div class="submetricname" *ngIf="row.metric.sublist.length>1">{{i.subWidgetName}}:
                                    </div>
                                    <div class="custom-dropdown"
                                        [style]="{'width': row.metric.sublist.length > 1 ? '75%' : '100%'}"
                                        (mouseleave)="row.metric.isDropdownOpen = false">
                                        <div class="custom-select" #select
                                            [style]="(row.metric.isDropdownOpen && i.isDropdown)?'border: 1.4px solid var(--BHP-Primary-DarkGreen3, rgba(128, 42, 183, 1));box-shadow: 0px 0px 12px 0px rgba(191, 191, 191, 0.15);':'border: 1px solid var(--BHP-Primary-Grey1, rgba(201, 201, 201, 1));box-shadow:0px'"
                                            (click)="row.metric.metric_select!=3 || metricGroupLength == 0 ? togglemetricDropdown(row,i,row.metric.sublist,select):togglemetricDropdown(row,i,row.metric.metricselect3,select)">

                                            <div class="selected-option">{{i.option}}</div>
                                            <div class=" arrow1">
                                                <div class="arrowToggle arrowCollapsedIcon"></div>
                                            </div>
                                        </div>
                                        <div class="custom-options" #options
                                            [ngClass]="{'dropdown-above': i.isDropdownAbove, 'dropdown-below': !i.isDropdownAbove}"
                                            *ngIf="row.metric.isDropdownOpen && i.isDropdown"
                                            (mousescroll)="row.metric.isDropdownOpen = false">
                                            <div class="dropdown-container">
                                                <div class="search-reset" *ngIf="row.metric.metric_select!=3 || metricGroupLength == 0 ">
                                                    <div class="sub-items-search">
                                                        <input class="searchinput" type="text" placeholder="Search"
                                                            [(ngModel)]="searchmetric" autocomplete="off"
                                                            name="searchmetric"
                                                            (ngModelChange)="filterOptions(i,row.metric.metric_select!=3 || metricGroupLength == 0 ?row.metric.metricselect1and2:row.metric.metricselect3,row.metric.metric_select)" />
                                                        <div class="search-icon">
                                                            <div class="search-icon-image"></div>
                                                        </div>
                                                    </div>
                                                    <div class="reset-button"
                                                        (click)="resetmetricselections(row.widgetNumber,i.subWidgetName,row.metric,row.metric.metric_select!=3 || metricGroupLength == 0 ?row.metric.metricselect1and2:row.metric.metricselect3,pageCounter,i,'')">
                                                        <div class="resetbtn"></div>
                                                    </div>
                                                </div>
                                                <div class="custom-option">
                                                    <div *ngIf="row.metric.metric_select!=3 || metricGroupLength == 0 ">
                                                        <div class="metricLev1" *ngFor="let lev1 of i.filteredoptions">
                                                            <div class="custom-select-lev1"
                                                                [style]="lev1.isSelected?'background-color:#efeeee;font-weight: bold;':'background-color:transparent;font-weight: normal;'"
                                                                *ngIf="row.metric.metric_select!=3 || metricGroupLength == 0  && lev1.option!=''">
                                                                <div class="select_number"
                                                                    [style]="row.metric.metric_select==1?'display:none':'display:block'">
                                                                    {{lev1.selectorder>0?lev1.selectorder:" "}}</div>
                                                                <div class="checkbox-container">
                                                                    <input [id]="lev1.option"
                                                                        [checked]="lev1.isSelected"
                                                                        (click)="metriccheckboxchecked($event,row,lev1,i,row.metric.filteredoptions,pageCounter)"
                                                                        [type]="row.metric.metric_select==1?'radio':'checkbox'"
                                                                        [class.disabled]="i.maxlimitreached && !lev1.isSelected && i.maxselect!=0"
                                                                        class="checkbox" />
                                                                </div>
                                                                <label class="level1-name"
                                                                    [class.disabled]="i.maxselect!=0 && i.maxlimitreached && !lev1.isSelected"
                                                                    [title]="lev1.option"
                                                                    [for]="lev1.option">{{lev1.option}}</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div *ngIf="row.metric.metric_select==3 && metricGroupLength != 0">
                                                        <div class="metricLev1"
                                                            [ngClass]="lev1.isDropdownOpen?'border':''"
                                                            *ngFor="let lev1 of i.filteredoptions">
                                                            <div class="custom-select-lev1"
                                                                *ngIf="row.metric.metric_select==3 && lev1.option!=''">
                                                                <!-- <div class="checkbox-container">
                                                        <input type="radio" class="checkbox" />
                                                    </div> -->
                                                                <div class="level1-name" [title]="lev1.option"
                                                                    (click)="togglemetriclev1Dropdown(row,lev1,i.subWidgetName)">
                                                                    {{lev1.option}}
                                                                </div>
                                                                <div class=" arrow1"
                                                                    (click)="togglemetriclev1Dropdown(row,lev1,i.subWidgetName)">
                                                                    <div class="arrowToggle arrowCollapsedIcon"></div>
                                                                </div>
                                                            </div>
                                                            <div class="search-reset"
                                                                *ngIf="row.metric.metric_select==3 && lev1.isDropdownOpen && metricGroupLength != 0">
                                                                <div class="sub-items-search">
                                                                    <input class="searchinput" type="text"
                                                                        placeholder="Search" [(ngModel)]="searchmetric"
                                                                        autocomplete="off" name="searchmetric"
                                                                        (ngModelChange)="filterOptions2(i,row.metric.metric_select!=3 || metricGroupLength == 0 ?row.metric.metricselect1and2:row.metric.metricselect3,row.metric.metric_select,lev1.option)" />
                                                                    <div class="search-icon">
                                                                        <div class="search-icon-image"></div>
                                                                    </div>
                                                                </div>
                                                                <div class="reset-button"
                                                                    (click)="resetmetricselections(row.widgetNumber,i.subWidgetName,row.metric,row.metric.metric_select!=3 || metricGroupLength == 0 ?row.metric.metricselect1and2:row.metric.metricselect3,pageCounter,i,lev1.option)">
                                                                    <div class="resetbtn"></div>
                                                                </div>
                                                            </div>
                                                            <div class="custom-options-lev2"
                                                                *ngIf="lev1.isDropdownOpen">

                                                                <div class="metricLev2"
                                                                    *ngFor="let lev2 of lev1.Level2">
                                                                    <div class="level2-container"
                                                                        [ngClass]="lev2.isSelected?'selectedDropdownItem':''">
                                                                        <div class="select_number"
                                                                            [style]="lev1.type=='radio'?'display:none':'display:block'"
                                                                            *ngIf="lev2.option!='' && lev1.option!=='METRIC GROUP'">
                                                                            {{lev2.selectorder>0?lev2.selectorder:" "}}
                                                                        </div>
                                                                        <div class="checkbox-container"
                                                                            *ngIf="lev2.option!=''">
                                                                            <input [id]="lev2.option" [type]="lev1.type"
                                                                                class="checkbox"
                                                                                [checked]="lev2.isSelected"
                                                                                [class.disabled]="i.maxlimitreached && !lev2.isSelected && i.maxselect!=0"
                                                                                (click)="metriccheckboxchecked($event,row,lev2,i,lev1,pageCounter)" />
                                                                        </div>
                                                                        <label class="level2-name" [for]="lev2.option"
                                                                            [class.disabled]="i.maxlimitreached && !lev2.isSelected && i.maxselect!=0"
                                                                            [title]="lev2.option">{{lev2.option}}</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
							<div class="table-cell col5 row" [ngClass]="{ 'enableDisableTrend': !row.trendDiv }">
                                <input type="checkbox" [(ngModel)]="row.trend">
                            </div>
                            <div class="table-cell col6 row">
                                <textarea style="width:100%; height:100%;resize: none;" class="staticText"
                                    placeholder="Info Text" [(ngModel)]="row.infoIcon"></textarea>
                            </div>
                        </div>
                    </div>

                </div>

                <!-- OR -->
                <!-- <div class="table-container" *ngIf="subSectionDisable">
                    <div><h1>No Data Available</h1></div>
                 </div> -->


                <!-- ----Button content----- -->
                <div class="button-block" [class.disabled]="deepCompare(checkTableData,tableData)">
                    <div class="SnapshotButtonFields" (click)="onResetClick()">
                        <div class="button-img clearAll-overlay"></div>
                        <div class="SnapshotButton">Reset</div>
                    </div>
                    <div class="SnapshotButtonFields" style="display: none;">
                        <div class="button-img save"></div>
                        <div class="SnapshotButton">Save</div>
                    </div>
                    <div class="SnapshotButtonFields" (click)="submit()">
                        <div class="button-img submit-overlay"></div>
                        <div class="SnapshotButton">Submit</div>
                    </div>
                </div>
            </div>
            <div class="pagination-block-overlay">
                <!-- ----- Pagination div---- -->
                <div style="position:relative;top:33.5%;left:34%;">
                    <div class="leftPageDiv" (click)="onPageClick('left',pageCounter)"
                        [ngClass]="{'disabled':disableLeftClick}">
                        <span class="material-symbols-outlined leftPageClick">arrow_circle_left</span>
                    </div>
                    <div class="rightPageDiv" (click)="onPageClick('right',pageCounter)"
                        [ngClass]="{'disabled':disableRightClick}">
                        <span class="material-symbols-outlined rightPageClick">arrow_circle_right</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>